import { motion } from "framer-motion";

const stats = [
  {
    label: "Human setter replacement",
    before: "Expensive VA or SDR hire",
    after: "A fraction of the cost, custom built",
  },
  {
    label: "Average response time",
    before: "2 to 4 hours",
    after: "Under 60 seconds",
  },
  {
    label: "Leads followed up",
    before: "40-60% lost",
    after: "100% automatic",
  },
];

export default function StatsSection() {
  return (
    <section data-testid="stats-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-14 md:mb-16"
        >
          <h2
            data-testid="stats-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight max-w-3xl"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            What happens when you stop chasing leads manually.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.08 }}
              data-testid={`stat-${i}`}
              className="bg-zinc-900/40 border border-white/[0.06] rounded-2xl p-7 md:p-8"
            >
              <p className="text-zinc-500 text-xs font-semibold uppercase tracking-wider mb-5">{stat.label}</p>

              {/* Before */}
              <div className="mb-5">
                <p className="text-zinc-600 text-xs uppercase tracking-wider mb-1">Without AI</p>
                <p className="text-zinc-400 text-lg font-semibold line-through decoration-zinc-600">{stat.before}</p>
              </div>

              {/* After */}
              <div>
                <p className="text-blue-400 text-xs uppercase tracking-wider mb-1">With AppoinText</p>
                <p className="text-white text-lg font-bold">{stat.after}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
